<div class="header row">
    <div class="col-12">
        <h2><strong>Segnalatori</strong></h2>
        <div *ngIf="false" class="breadcrumb-wrapper hidden-xs">
            <ol class="breadcrumb">
                <li class="active">Segnalatori</li>
            </ol>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12" style="margin-bottom: 80px;">
        <div class="panel">
            <div class="panel-content">
                <div *ngIf="referrers!.length > 0; else referrersEmpty">
                    <ng-container *ngIf="(referrers
                          | advancedSearchFilter: advancedFields: advancedState
                          | referrerGlobalSearchFilter: globalSearchFilterValue
                          | referrerIdFilter: idFilterValue
                          | referrerNameFilter: nameFilterValue
                          | referrerSurnameFilter: surnameFilterValue
                          | referrerEmailFilter: emailFilterValue) as filteredReferrers">
                        <app-advanced-search [fields]="advancedFields"
                                             [state]="advancedState"
                                             (stateChange)="onAdvancedStateChange($event)"></app-advanced-search>

                        <div class="dashboard-toolbar">
                            <div class="toolbar-left">
                                <label for="items-per-page">Mostra</label>
                                <input [(ngModel)]="paginationConfig.itemsPerPage"
                                       (change)="paginationConfig.currentPage = 1"
                                       class="form-control input-sm form-white items-per-page-input"
                                       id="items-per-page"
                                       name="items-per-page"
                                       type="number">
                                <span class="results-count">
                                    di {{ filteredReferrers.length }}
                                    {{ filteredReferrers.length === 1 ? 'segnalatore' : 'segnalatori' }}
                                </span>
                                <button *ngIf="hasActiveFilters()"
                                        type="button"
                                        class="btn btn-link btn-sm clear-filters-link"
                                        (click)="clearFilters()">
                                    Pulisci filtri
                                </button>
                            </div>

                            <div class="toolbar-right">
                                <button type="button"
                                        class="btn btn-sm btn-secondary export-csv-btn"
                                        [disabled]="filteredReferrers.length === 0"
                                        (click)="exportCsv(filteredReferrers)"
                                        title="Esporta in CSV i segnalatori filtrati">
                                    <i class="fa fa-download" style="margin-right: 7px;"></i>CSV
                                </button>
                                <a (click)="openCreateReferrerModal()"
                                   class="edit btn btn-sm btn-primary">
                                    <i class="fa fa-plus" style="margin-right: 7px;"></i>Crea Nuovo Segnalatore
                                </a>
                            </div>
                        </div>

                        <div class="row mobile-search-row">
                            <div class="col-xs-12">
                                <div class="form-group prepend-icon">
                                    <input [(ngModel)]="globalSearchFilterValue"
                                           (ngModelChange)="onFilterChange()"
                                           type="text"
                                           class="form-control form-white"
                                           id="mobile-global-search"
                                           name="mobile-global-search"
                                           placeholder="Cerca ID, nome, cognome, email...">
                                    <i class="icon-magnifier"></i>
                                </div>
                            </div>
                        </div>

                        <div class="table-container table-scroll">
                            <table class="table table-hover table-referrer" [appStableColumns]="columnLayoutToken">
                                <thead>
                                <tr class="column-titles">
                                    <th class="col-id">ID Segnalatore</th>
                                    <th class="col-flex">Nome</th>
                                    <th class="col-flex">Cognome</th>
                                    <th>Email</th>
                                    <th class="text-right col-sticky col-sticky-actions">Azioni</th>
                                </tr>
                                <tr class="column-filters hidden-xs hidden-sm">
                                    <th class="col-id">
                                        <input [(ngModel)]="idFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="ID"
                                               aria-label="Filtra per ID segnalatore">
                                    </th>
                                    <th class="col-flex">
                                        <input [(ngModel)]="nameFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Nome"
                                               aria-label="Filtra per nome">
                                    </th>
                                    <th class="col-flex">
                                        <input [(ngModel)]="surnameFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Cognome"
                                               aria-label="Filtra per cognome">
                                    </th>
                                    <th>
                                        <input [(ngModel)]="emailFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Email"
                                               aria-label="Filtra per email">
                                    </th>
                                    <th class="col-sticky col-sticky-actions"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngIf="filteredReferrers.length === 0">
                                    <td colspan="5" class="filtered-empty-state">
                                        <div class="filtered-empty-pin">
                                            <p>Nessun risultato con i filtri attuali.</p>
                                            <button type="button" class="btn btn-sm btn-secondary" (click)="clearFilters()">Pulisci filtri</button>
                                        </div>
                                    </td>
                                </tr>
                                <tr *ngFor="let referrer of filteredReferrers | paginate: paginationConfig">
                                    <td class="col-id" (click)="goToReferrerDetail(referrer.IDReferrer)">{{ referrer.IDReferrer }}</td>
                                    <td (click)="goToReferrerDetail(referrer.IDReferrer)">{{ referrer.Name }}</td>
                                    <td (click)="goToReferrerDetail(referrer.IDReferrer)">{{ referrer.Surname }}</td>
                                    <td class="col-email" (click)="goToReferrerDetail(referrer.IDReferrer)">
                                        <span *ngIf="referrer.Email; else noReferrerEmail" class="referrer-email-badge">
                                            <i class="fa fa-envelope-o referrer-email-badge-icon" aria-hidden="true"></i>
                                            <span class="referrer-email-badge-text">{{ referrer.Email }}</span>
                                        </span>
                                        <ng-template #noReferrerEmail>
                                            <span class="referrer-email-empty">—</span>
                                        </ng-template>
                                    </td>
                                    <td class="text-right col-sticky col-sticky-actions">
                                        <div ngbDropdown
                                             [autoClose]="'outside'"
                                             container="body"
                                             placement="bottom-right"
                                             class="btn-group">
                                            <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                                                Azioni
                                            </button>
                                            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right row-actions-menu">
                                                <a [routerLink]="['/segnalatori/modifica', referrer.IDReferrer]" class="dropdown-item" type="button"><i class="fa fa-pencil"></i>Modifica</a>
                                                <button (click)="openDeleteReferrerModal(referrer)" class="dropdown-item" type="button"><i class="fa fa-trash-o"></i>Elimina</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <pagination-controls *ngIf="filteredReferrers.length > 0"
                                             (pageChange)="pageChanged($event)"
                                             [autoHide]="paginationParams.autoHide"
                                             [maxSize]="paginationParams.maxSize"
                                             [responsive]="paginationParams.responsive"
                                             [previousLabel]="paginationLabels.previousLabel"
                                             [nextLabel]="paginationLabels.nextLabel"
                                             [screenReaderPaginationLabel]="paginationLabels.screenReaderPaginationLabel"
                                             [screenReaderPageLabel]="paginationLabels.screenReaderPageLabel"
                                             [screenReaderCurrentLabel]="paginationLabels.screenReaderCurrentLabel"
                        ></pagination-controls>
                    </ng-container>
                </div>
                <ng-template #referrersEmpty>
                    <div>
                        <div class="row">
                            <div class="col-md-3 col-md-offset-9 col-xs-12" style="text-align: right;">
                                <a (click)="openCreateReferrerModal()" class="edit btn btn-sm btn-primary"><i class="fa fa-plus" style="margin-right: 7px;"></i>Crea Nuovo Segnalatore</a>
                            </div>
                        </div>
                        <div style="height: 200px; text-align: center; padding-top: 85px;">
                            Nessun segnalatore trovato.
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
